import React, { Fragment } from 'react';
import { intlShape } from 'react-intl';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import { uniq } from 'ramda';

import { multiply } from 'utils/calculator';
import { Row, Column } from 'components/shared/Layout';
import currencySymbols from 'constants/currencies';
import classOfService from 'constants/propTypes/classOfService';

import Info from './Info';
import { TravelDate, ExtrasList } from './SegmentInfo.styles';

const SegmentInfo = ({ date, departsAt, arrivesAt, origin, destination, classOfService, trainNumber, extras, intl: { formatMessage } }) => {
  const departValue = `${origin.name} (${origin.shortCode}) ${formatMessage({
    id: 'exchangeConfirmation.at'
  })} ${departsAt}`;

  const arriveValue = `${destination.name} (${destination.shortCode}) ${formatMessage({
    id: 'exchangeConfirmation.at'
  })} ${arrivesAt}`;

  return (
    <>
      <TravelDate data-testid="travel-date">{moment.utc(date).format('Do MMM YYYY')}</TravelDate>
      <Info value={departValue} labelId="segmentInfo.depart" dataId="depart" />
      <Info value={arriveValue} labelId="segmentInfo.arrive" dataId="arrives" />
      <Info value={classOfService.name} labelId="segmentInfo.class" dataId="class" />
      <Info value={trainNumber} labelId="segmentInfo.trainNo" dataId="trainNo" />
      <ExtrasList>
        {uniq(extras.map((extra) => extra.passenger.id)).map((paxId) => (
          <Fragment key={paxId}>
            {uniq(extras.filter((e) => e.passenger.id === paxId).map((e) => e.tariffDetails.tariffCode)).map((code) => {
              const extrasOfType = extras.filter((e) => e.passenger.id === paxId && e.tariffDetails.tariffCode === code);
              const count = extrasOfType.length;
              const {
                passenger,
                name,
                currency,
                price,
                tariffDetails: { tariffCode }
              } = extrasOfType[0];

              return (
                <Fragment key={tariffCode}>
                  <Row>
                    <Column span={6} data-testid="pax-name">
                      {passenger.firstName} {passenger.lastName}
                    </Column>
                    <Column span={8} data-testid="extra-name">
                      {count} {name}
                    </Column>
                    <Column span={2} data-testid="extra-price">{`${currencySymbols[currency]}${multiply(count, price)}`}</Column>
                  </Row>
                  <hr />
                </Fragment>
              );
            })}
          </Fragment>
        ))}
      </ExtrasList>
    </>
  );
};

SegmentInfo.propTypes = {
  intl: intlShape,
  date: PropTypes.string,
  departsAt: PropTypes.string,
  arrivesAt: PropTypes.string,
  origin: PropTypes.shape({
    uic: PropTypes.string,
    shortCode: PropTypes.string,
    name: PropTypes.string
  }),
  destination: PropTypes.shape({
    uic: PropTypes.string,
    shortCode: PropTypes.string,
    name: PropTypes.string
  }),
  classOfService: classOfService,
  trainNumber: PropTypes.string,
  extras: PropTypes.arrayOf(PropTypes.object)
};

export default SegmentInfo;
